import BaseAPIService from 'src/services/base/base-api-service';
import ShipAddressModel from 'src/model/shipAddress.model';

class AccountShipService extends BaseAPIService<ShipAddressModel> {
  public accountEmailEndpoint: string = '/accountapp/v1/email';
  constructor() {
    super(ShipAddressModel);
  }

  public addShipAddress(params: ShipAddressModel): Promise<any> {
    return this.create(`${this.accountEmailEndpoint}/add/ship/address`, params);
  }

  public changeShipAddress(params: ShipAddressModel): Promise<any> {
    return this.create(
      `${this.accountEmailEndpoint}/change/ship/address`,
      params
    );
  }

  public removeShipAddress(params: {
    addressId: number;
    customerNumber: number;
  }): Promise<any> {
    return this.create(
      `${this.accountEmailEndpoint}/remove/ship/address`,
      params
    );
  }
}

const accountShipServiceInstance = new AccountShipService();
Object.freeze(accountShipServiceInstance);

export default accountShipServiceInstance;
